/**
 * Convert special characters to HTML5 entities.
 *
 * Performed translations:
 * & (ampersand) to &amp;
 * " (double quote) to &quot;
 * ' (single quote) to &apos;
 * < (less than) to &lt;
 * > (greater than) to &gt;
 *
 * @param {String} str
 * @returns {String}
 */
const htmlspecialchars = function(str) {
	return str.replace(/[&<>'"]/g, tag => ({
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		"'": '&apos;',
		'"': '&quot;'
	}[tag]));
};
export default htmlspecialchars;
